import { apiClient } from "@api/apiClient";

import { GetDealTypeCategoryResponse } from "./dealTypeCategory.interface";

const API_ENDPOINT = {
  get: (draftArticleId: number) =>
    `/des/article-content/deal-type-category/${draftArticleId}`,
};

export const dealTypeCategoryApis = {
  get: async (draftArticleId: number) => {
    const { data } = await apiClient.get<GetDealTypeCategoryResponse>(
      API_ENDPOINT.get(draftArticleId),
    );
    return data;
  },
};
